import { useBootstrap } from '@/hooks/useBootstrap'

/** Vlastnosti pre `TimeInput` podľa rozdelenia hodín v kalendári
 *  (`settings.parts_in_hour`) - pri dieliku 30 min sa dá zadať len
 *  10:00, 10:30… Dieliky sa rátajú od začiatku dňa (`start_hour`). */
export function useGridTime() {
  const { data } = useBootstrap()
  const parts = data?.settings.parts_in_hour || 2
  const startHour = Number(data?.settings.start_hour ?? 0)
  return {
    step: Math.max(Math.round(60 / parts), 1),
    origin: Math.round(startHour * 60),
    snap: true,
  }
}
